'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorWrapText = function EditorWrapText(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 19h6v-2H4v2zM20 5H4v2h16V5zm-3 6H4v2h13.25c1.1 0 2 .9 2 2s-.9 2-2 2H15v-2l-3 3 3 3v-2h2c2.21 0 4-1.79 4-4s-1.79-4-4-4z' })
  );
};
EditorWrapText = (0, _pure2.default)(EditorWrapText);
EditorWrapText.displayName = 'EditorWrapText';
EditorWrapText.muiName = 'SvgIcon';

exports.default = EditorWrapText;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/editor/wrap-text.js
// module id = 2275
// module chunks = 0